module.exports = __webpack_public_path__ + "media/dove.34b175cd.mp4";